module.exports = __webpack_public_path__ + "static/gallery-5-4f4f3ed1bf9ebab1cae8004dd018e526.jpg";